// extracted by mini-css-extract-plugin
module.exports = {"container":"Recorder_container__3dM8x","controls":"Recorder_controls__2F6sc"};